import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { InterceptorModule } from "@interceptors/interceptor.module";
import { ErrorModule } from "./error.module";
import { NotFoundComponent } from "@pages/errors/404/not-found.component";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MainLayout } from "./layouts/main/main.layout";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MatIconModule } from "@angular/material/icon";

@NgModule({ declarations: [AppComponent, NotFoundComponent, MainLayout],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        InterceptorModule,
        ErrorModule,
        ToastrModule.forRoot(),
        BsDropdownModule.forRoot(),
        MatIconModule,
  ], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
